export { ThemedIllustration } from "./ThemedIllustration";
